import { AxiosError } from "axios";

// 503 (Service Unavailable) is what the API answers with when it's rejecting requests under load
// (e.g. a burst of bulk-creation calls) — the request never reached application logic, so retrying
// it is safe.
const RetryableHttpStatuses = [503];

const MaxRetries = 2;
const RetryDelayMs = 1000;

const isRetryableError = (error: unknown): boolean => error instanceof AxiosError && RetryableHttpStatuses.includes(error.response?.status ?? 0);

/** Retries `task` with a fixed backoff when it fails with a retryable HTTP status (503). */
export const withRetry = async <T>(task: () => Promise<T>, maxRetries: number = MaxRetries): Promise<T> => {
  for (let attempt = 0; ; attempt++) {
    try {
      return await task();
    } catch (e) {
      if (attempt >= maxRetries || !isRetryableError(e)) throw e;
      await new Promise((resolve) => setTimeout(resolve, RetryDelayMs * (attempt + 1)));
    }
  }
};
